import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  width: 100%;
`;

export const ContainerAnalyst = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.min.sm} {
    padding: ${({ theme }) => theme.space["space-4"]};
  }
`;

export const ParagraphContainer = styled.div`
  display: flex;
`;
